import * as React from "react";
const FlagSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6,11 L6,15 L5,15 L5,4 L13.5,4 C13.7761424,4 14,4.22385763 14,4.5 C14,4.60848656 13.9654492,4.70890335 13.9067512,4.79084693 L12.1009252,7.5 L13.9294869,10.2438408 C13.9742666,10.3187588 14,10.4063742 14,10.5 C14,10.7761424 13.7761424,11 13.5,11 L6,11 Z M6,10 L12.5657415,10 L10.8990748,7.5 L12.5657415,5 L6,5 L6,10 Z" }));
FlagSmall.displayName = "FlagSmall";
var FlagSmall_default = FlagSmall;
export {
  FlagSmall_default as default
};
